'use strict'

module.exports = {
  isInUS() {
    return window.Groupon.division && window.Groupon.division.country === 'USA';
  }
};